import { CompagniaAssicurativaList } from './../types/index';
import axios from 'axios';
import { CompagniaAssicurativa, IdVersion, CompagniaAssicurativaCreateCommand, CompagniaAssicurativaUpdateCommand } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/compagnie-assicurative';

export const getByKey = async (id: number): Promise<CompagniaAssicurativa> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};

export const getList = async (): Promise<CompagniaAssicurativaList[]> => {
    return (await axios.get(`${baseUrl}`)).data;
};

export const create = async (command: CompagniaAssicurativaCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: CompagniaAssicurativaUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};

